import { nodeListToArray } from '../helpers/nodeListToArray';
import { debounce } from 'lodash';
import { enableTabbableChildren } from '../helpers/enableTabbableChildren';
import { disableTabbableChildren } from '../helpers/disableTabbableChildren';
import '../helpers/closestPolyfill';

let assign = require('lodash.assign');

export interface IAccordionOptions {
    container?: HTMLElement;
}

export class Accordion {
    options: IAccordionOptions = {

    }

    container: HTMLElement;
    panels: Array<HTMLElement>;
    triggers: Array<HTMLButtonElement>;
    activePanel: any;
    activeTrigger: any;

    constructor(options: IAccordionOptions) {
        assign(this.options, options);
        this.container = this.options.container;
        this.panels = nodeListToArray(this.container.querySelectorAll('[role="region"]'));
        this.triggers = nodeListToArray(this.container.querySelectorAll('[aria-controls]'));

        window.addEventListener(
            'resize',
            debounce(() => {
                this.setAccordionHeights();
            }, 100)
        );
        window.addEventListener(
            'load',
            debounce(() => {
                this.setAccordionHeights();
            }, 100)
        );

        this.container.addEventListener('keydown', this.handleKeydown.bind(this));

        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', this.accordionClick.bind(this));
        });
        this.panels.forEach(panel => {
            disableTabbableChildren(panel);
        });
        setTimeout(() => {
            this.setAccordionHeights();
        }, 0);

        if (window.innerWidth < 640) {
            this.closeInactivePanels();
        }
    }

    setAccordionHeights() {
        this.panels.forEach(panel => {
            // override css styles so that we can capture the actual height of the collapsed panel
            panel.parentElement.setAttribute('style', 'position: relative');
            panel.setAttribute('style', 'opacity: 0; height: auto !important; position: absolute');
            let panelHeight = panel.offsetHeight;          
            let boundingHeight = document.getElementById(panel.id).getBoundingClientRect().height;

            panel.removeAttribute('style');
            panel.style.height = `${panelHeight}px`;
        });
    }

    accordionClick(e) {
        this.activePanel = this.container.querySelector(`#${e.currentTarget.getAttribute('aria-controls')}`);
        this.activeTrigger = e.currentTarget;

        this.toggleActivePanel(); 
        //if (this.options.oneOpenAtATime) {
        //this.closeInactivePanels();
        if (window.innerWidth <= 640) {
            this.closeOpenAccordions(this.activeTrigger);
        }
        //}
    }


    toggleActivePanel() {
        if (this.activeTrigger.getAttribute('aria-expanded') === 'true') {
            this.closePanel(this.activeTrigger, this.activePanel);
        }
        else {
            this.openPanel(this.activeTrigger, this.activePanel);
        }

        if (window.innerWidth <= 640) {
            this.closeInactivePanels();
        }

    }

    closeInactivePanels() {
        this.triggers.forEach(trigger => {
            if (trigger !== this.activeTrigger) {
                let curPanel = this.container.querySelector(`#${trigger.getAttribute('aria-controls')}`);
                this.closePanel(trigger, curPanel);
            }
        });
    }

    openPanel(trigger, panel) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        enableTabbableChildren(panel);
        this.adjustAlertAccordionTriggerText(trigger, "Show Less");
    }

    closePanel(trigger, panel) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        disableTabbableChildren(panel);
        this.adjustAlertAccordionTriggerText(trigger, "Show More");
    }

    handleKeydown(e) { // mostly taken from WAI-ARIA Authoring guide: https://w3c.github.io/aria-practices/examples/accordion/accordion.html
        const key = e.which.toString();
        const target = e.target;
        const ctrlModifier = (e.ctrlKey && key.match(/33|34/));
        if (target.hasAttribute('aria-controls')) {
            if (key.match(/38|40/) || ctrlModifier) {
                const index = this.triggers.indexOf(target);
                const direction = (key.match(/34|40/)) ? 1 : -1;
                const length = this.triggers.length;
                const newIndex = (index + length + direction) % length;

                this.triggers[newIndex].focus();

                e.preventDefault();
            }
            else if (key.match(/35|36/)) {
                // 35 = End, 36 = Home keyboard operations
                switch (key) {
                    // Go to first accordion
                    case '36':
                        this.triggers[0].focus();
                        break;
                    // Go to last accordion
                    case '35':
                        this.triggers[this.triggers.length - 1].focus();
                        break;
                }

                e.preventDefault();
            }
        }
        else if (ctrlModifier) {
            // Control + Page Up/ Page Down keyboard operations
            // Catches events that happen inside of panels
            this.panels.forEach((panel, index) => {
                if (panel.contains(target)) {
                    this.triggers[index].focus();

                    e.preventDefault();
                }
            });
        }
    }

    closeOpenAccordions(acttrigger) {
        this.triggers.forEach(trigger => {
            if (trigger !== acttrigger) {
                let curPanel = this.container.querySelector(`#${trigger.getAttribute('aria-controls')}`);
                this.closePanel(trigger, curPanel);
            }
        });
    }

    adjustAlertAccordionTriggerText(trigger, triggerText) {
        let triggerElement = trigger as HTMLElement;

        if (triggerElement.classList.contains('adage-alert-accordion-trigger')) {
            let originalTriggerText = triggerElement.querySelector('.adage-alert-accordion-trigger-text') as HTMLElement;

            originalTriggerText.innerHTML = triggerText;
        }
    }
}


//let accordionLists = nodeListToArray(
//    document.querySelectorAll('[data-accordion-list]')
//);
//let resizeTimer;

//class AccordionsOptions {
//    oneOpenAtATime: boolean = true;
//}

//export class Accordion {
//    options: AccordionsOptions = new AccordionsOptions();

//    constructor(private optArg?: any) {
//        window.addEventListener(
//            'resize',
//            debounce(() => {
//                this.setAccordionHeights.bind(this);
//            }, 50)
//        );
//        accordionLists.forEach(accordionList => {
//            accordionList.addEventListener(
//                'click',
//                function (event) { event.preventDefault() },
//                false
//            );
//            accordionList.addEventListener(
//                'click',
//                this.accordionClick.bind(this),
//                false
//            );
//            let panels = nodeListToArray(accordionList.querySelectorAll('[aria-hidden]'));
//            panels.forEach(panel => {
//                disableTabbableChildren(panel);
//            })
//        });
//        //Check for Options
//        if (this.optArg === undefined) this.optArg = new AccordionsOptions();
//        else {
//            this.options.oneOpenAtATime =
//                this.optArg.oneOpenAtATime === undefined
//                    ? this.options.oneOpenAtATime
//                    : this.optArg.oneOpenAtATime;
//        }

//        //if mobile, close all accordion panels
//        if (window.innerWidth <= 640) {
//            var allAccordionControls = Array.prototype.slice.call(document.querySelectorAll('[aria-controls]'));
//            allAccordionControls.forEach(control => {
//                var controlId = control.getAttribute('aria-controls');
//                let accordionToToggle = document.querySelector('#' + controlId);

//                this.closeAccordion(accordionToToggle);
//            })
//        }
//    }

//    setAccordionHeights() {
//        accordionLists.forEach(accordionList => {
//            let openAccordions = nodeListToArray(accordionList.querySelectorAll('[aria-hidden="false"]'));
//            if (openAccordions.length > 0) {
//                openAccordions.forEach(openAccordion => {
//                    let accordionToSize = openAccordion.querySelector(
//                        '[data-accordion-content-id]'
//                    );
//                    let accordionNewHeight = accordionToSize.getBoundingClientRect()
//                        .height;
//                    openAccordion.style.height = accordionNewHeight + 'px';
//                });
//            }
//        });
//    }

//    accordionClick(e) {
//        if (e.target !== e.currentTarget) {
//            let accordionToOpenId = e.target.getAttribute('aria-controls');
//            if (accordionToOpenId === null) {
//                accordionToOpenId = e.target.closest('[aria-controls]').getAttribute('aria-controls');
//            }
//            let accordionToToggle = document.querySelector('#' + accordionToOpenId);
//            let accordionContentHeight = document.querySelector('[data-accordion-content-id="' + accordionToOpenId + '"]').getBoundingClientRect().height;
//            if (this.options.oneOpenAtATime && window.innerWidth <= 400) {
//                this.closeOpenAccordions(accordionToToggle);
//            }
//            if (accordionToToggle.getAttribute('aria-hidden') == 'false') {
//                this.closeAccordion(accordionToToggle);
//            } else {
//                this.openAccordion(accordionToToggle, accordionContentHeight);
//            }
//            this.setAccordionHeights();
//        }
//        e.stopPropagation();
//    }

//    openAccordion(accordionToOpen, accordionToOpenHeight) {
//        accordionToOpen.setAttribute('style', 'height:' + accordionToOpenHeight + 'px');
//        accordionToOpen.setAttribute('aria-hidden', 'false');
//        enableTabbableChildren(accordionToOpen);
//        let id = accordionToOpen.id;
//        document.querySelector('[aria-controls="' + id + '"]').setAttribute('aria-expanded', 'true');
//    }

//    closeAccordion(accordionToClose) {
//        accordionToClose.setAttribute('style', 'height: 0px');
//        accordionToClose.setAttribute('aria-hidden', 'true');
//        disableTabbableChildren(accordionToClose);
//        let id = accordionToClose.id;
//        document.querySelector('[aria-controls="' + id + '"]').setAttribute('aria-expanded', 'false');
//    }

//    closeOpenAccordions(exception) {
//        let container = exception.closest('ul');

//        if (container != null) {
//            let openAccordions = nodeListToArray(container.querySelectorAll('[aria-hidden="false"]'));
//            openAccordions.forEach(openAccordion => {
//                if (openAccordion !== exception) {
//                    this.closeAccordion(openAccordion);
//                }
//            });
//        }
//    }
//}
